import { EyeOutlined } from '@ant-design/icons';
import { Flex } from 'antd';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '../Text';

export const ImagePreviewMask: FC = () => {
  const { t } = useTranslation();
  return (
    <Flex gap={4} align="center" justify="center">
      <EyeOutlined />
      <Text text={t('preview')} color="white" />
    </Flex>
  );
};
